import { Injectable } from '@angular/core';
// import { ChatCommonService } from './chat-common.service';

@Injectable({
  providedIn: 'root'
})
export class ChatErrorService {
  errorsRegisters: any = {
    unsupported_video_format: false,
    no_content_file: false,
    max_video_limit: false,
    unsupported_file: false,
    maxSize: false,
    maxLimit: false,
  };

  constructor(

  ) {

  }

  hideSnackbarToast(snackbar: HTMLElement) {
    setTimeout(() => {
      if (snackbar && snackbar.classList.contains('show-snackbar')) {
        snackbar.classList.remove("show-snackbar");
      }
    }, 3000);
  }

  // onToastClick(event: Event, chatCommonService?: ChatCommonService) {
  //   const targetElement = event.target as HTMLElement;

  //   let toast: HTMLElement = null;
  //   // Check if the clicked element has the class 'hs-toast'
  //   if (targetElement.classList.contains('hs-toast')) {
  //     toast = targetElement;
  //   } else {
  //     // If the click was on a child element inside 'hs-toast', find the closest 'hs-toast'
  //     const closestToast = targetElement.closest('.hs-toast') as HTMLElement;
  //     if (closestToast) {
  //       toast = closestToast;
  //     }
  //   }
  //   if (toast) {
  //     // console.log('Clicked  on toast:', toast);
  //     if (targetElement?.tagName?.toLowerCase() == 'b') {
  //       if (targetElement?.classList.contains('stop-cloud-recording')) {
  //         if (chatCommonService) {
  //           chatCommonService.cloudRecording = false;
  //           toast?.remove();
  //         }
  //       }
  //     }
  //   }
  // }


  showSnackbarToast(message: string, theme: '' | 'success' | 'error' | 'warning' = 'success', autoCloseTimeDefault = 4500, closeButton = true) {
    // Function to show a toast message
    if (!theme) {
      theme = 'success';
    }
    function showToast(options) {
      try {
        const wrapper = document.querySelector(options.eleWrapper);
        const toast = createToast(options);
        toast.style.display = 'none';
        wrapper.appendChild(toast);
        fadeIn(toast, 1);
        if (options.autoClose) {
          let autoCloseTime = options.autoCloseTime || autoCloseTimeDefault;
          if (autoCloseTime < 1000) autoCloseTime = autoCloseTimeDefault;
          // toast.addEventListener('click', (evt)=>{
          //   toast.remove();

          // });
          setTimeout(() => {
            if (toast) {
              toast.style.transition = 'margin-top 0.5s, opacity 0.5s';
              toast.style.marginTop = '-50px';
              toast.style.opacity = '0';

              setTimeout(() => {
                toast?.remove();
                if (options.afterClose) options.afterClose();
              }, 500);
            }
          }, autoCloseTime);
        }
        const closeBtn = toast.querySelector('.hs-close');
        if (closeBtn) {
          closeBtn.addEventListener('click', () => {
            toast.remove();
            if (options.afterClose) options.afterClose();
          });
        }
        if (options.afterShow) options.afterShow();
      } catch (error) {

      }
    }

    // Function to create the HTML structure of the toast message
    function createToast(options) {
      const finalOptions = toastCaseValidation(options);
      const div = document.createElement('div');
      div.className = `hs-toast hs-theme-${options.theme.toLowerCase()}`;
      div.innerHTML = `
        <div class="hs-toast-inner">
        <div class="hs-toast-msg">${finalOptions.msg}</div>
        <div class="hs-toast-icons">${finalOptions.icon}</div>
        <div class="hs-toast-action">${finalOptions.close}</div>
        </div>`;
      return div;
    }

    // Function to validate and prepare options for the toast
    function toastCaseValidation(options) {
      let themeIcon: string = '';
      const closeButton = options.closeButton === false ? '' : '<button type="button" class="hs-close">&#10006;</button>';
      switch (options.theme) {
        case 'error':
          themeIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="red" class="bi bi-x-lg" viewBox="0 0 16 16">
<path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
</svg>`;
          break;
        case 'success':
          // themeIcon = ``;
          break;
        case 'warning':
          themeIcon = ``;
          break;
        default:
        // themeIcon = '<svg ...> <!-- Default icon SVG here --> </svg>';
      }

      const msg = Array.isArray(options.msg) && options.msg.length > 1
        ? `<ul>${options.msg.map(val => `<li>${val}</li>`).join('')}</ul>`
        : options.msg || 'No Message';

      return { icon: themeIcon, close: closeButton, msg: msg };
    }

    // Utility function to fade in an element
    function fadeIn(element, duration) {
      element.style.opacity = 0;
      element.style.display = 'block';

      let last = +new Date();
      const tick = function () {
        element.style.opacity = +element.style.opacity + (+(new Date()) - last) / duration;
        last = +new Date();

        if (+element.style.opacity < 1) {
          ((window as any).requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
        }
      };

      tick();
    }

    showToast(
      {
        eleWrapper: '#example',
        msg: message,
        theme: theme,
        closeButton: closeButton,
        autoClose: true,
      }
    );
  }

  //reset errros registered
  resetErrorsRegisters() {
    for (const key in this.errorsRegisters) {
      this.errorsRegisters[key] = false;
    }
  }

  showError(error: { message: string, theme?: 'info' | 'success' | 'error' | 'warning' }, typeOfError = 'success') {
    let text = "";
    let msg = error?.message;
    if ((msg == 'max_video_limit' || msg == 'maxLimit') && this.errorsRegisters[msg]) {
      return;
    }
    this.errorsRegisters[msg] = true;
    if (msg == 'unsupported_video_format') {
      text = 'A video file you tried is not supported. Upload video (mp4 only)';
    }
    else if (msg == 'no_content_file') {
      text = 'One document you tried adding has no content';
    }
    else if (msg == 'max_video_limit') {
      text = 'You can only select upto 3 video files at once';
    }
    else if (msg == 'unsupported_file') {
      text = 'One file you tried is not supported. Please upload an image,document or video(mp4).';
    }
    else if (msg == 'maxSize') {
      text = 'Please upload file upto 25MB';
    }
    else if (msg == "maxLimit") {
      text = 'You can select up to 15 files.';
    }
    else if (msg) {
      text = msg;
    }
    if (text)
      this.showSnackbarToast(text, error?.theme as any);
  }

}
